import React , {useState} from "react";
import Library from 'library';
import styles from './index.module.scss';
import { umengTrack_healthcare } from 'library/jsbridge/config';
const { Fetch, Platform, JsBridge } = Library;

export const BottomButton2 = (props) => {
    const [show,setShow] = useState(false);

    return <div className={`${styles.bottomButton} ${window.pageConfig && window.pageConfig.isFullscreen ? styles.active : ''}`}>
        <div className={styles.content}>
            {/* 改了括号 */}
            <button className={styles.button} onClick={() => {
               setShow(true)
            }}></button>
           
        </div>
         {
            show?<div className={styles.modal} onClick={()=>setShow(false)}>
                    <div className={styles.content}>
                        <div className={styles.phone} onClick={()=>{
                            if (Platform.name() === 'GuApp') {
                                JsBridge.tel('400-920-3932');
                            } else {
                                window.location.href = 'tel:400-920-3932';
                            }
                            if (Platform.check.isApp()) {
                                JsBridge.UmengTrack(umengTrack_healthcare.phone);
                            }
                        }}>
                            400-920-3932
                        </div>
                        <div className={styles.line}></div>
                        <div className={styles.phone} onClick={()=>{
                            if (Platform.name() === 'GuApp') {
                                JsBridge.tel('021-63153610');
                            } else {
                                window.location.href = 'tel:021-63153610';
                            }
                            if (Platform.check.isApp()) {
                                JsBridge.UmengTrack(umengTrack_healthcare.phone);
                            }
                        }}>
                            021-63153610
                        </div>
                        <div className={styles.line}></div>
                        <div className={styles.phone} onClick={()=>setShow(false)}>
                            取消
                        </div>
                    </div>
                  
                </div>:null
            }
    </div>
}